export const CancelLineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="12" cy="12" fill="#EBF0F6" r="10" />
      <path
        d="M11.989 11.989L10 10l1.989 1.989L13.977 10l-1.988 1.989zm0 0L10 13.977l1.989-1.988 1.988 1.988-1.988-1.988z"
        stroke="#333A40"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>
)
